module.exports = __webpack_public_path__ + "fonts/GothamSSm-BookItalic.19687831.woff";